import './Token-942271b0.css';

var classes = {"Token":"prc-Token-Token-L2-At","LeadingVisualContainer":"prc-Token-LeadingVisualContainer-YTg7O","LargeLeadingVisual":"prc-Token-LargeLeadingVisual-UdxDk"};

export { classes as default };
